export default __webpack_public_path__ + "static/media/githubUser.5cc5556f.png";